import React, { Component } from "react"
import { FormGroup, Radio, Panel } from "react-bootstrap"
import Ajax from "superagent"


/**
 * Note: idk why this doesn't work with credentials: same origin
 * i need to use the "api key"
 */

class PaymentMethods extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      
    }
  }

  componentDidMount() {
    Ajax
      .get("/getproviders")
      .then(res => {
        this.setState({providers: res.body})
      })
  }

  setProvider(vendor, provider) {
    Ajax
      .post("/setprovider")
      .send({vendor, provider})
      .then(res => {
        this.setState({providers: res.body})
      })
  }
  

  render() {
    const vendors = [
      {id: 'wechatpay', label: 'WeChat', img: '/static/icons/wechatpay.svg'}, 
      {id: 'alipay', label: 'AliPay', img: '/static/icons/alipay.svg'}
    ]

    const providers = [
      {id: 'yabandpay', label: 'YabandPay'},
      {id: 'starpay', label: 'StarPay'}
    ]

    return !this.state.providers 
      ?  "Loading..." 
      :  (
        <div style={{display: "flex", width: "100%"}}>
          {}
          {vendors.map(vendor => (
            <Panel key={vendor.id} style={{flexGrow: 2}}>
              <Panel.Heading style={{display: 'flex', justifyContent: 'center', alignItems: "center"}}>
                {vendor.label}
                <img src={vendor.img} width="50px" height="50px"></img>
              </Panel.Heading>
              <Panel.Body>
                <FormGroup>
                  {providers.map(provider => (
                    <Radio
                      key={provider.id}
                      checked={this.state.providers[vendor.id] == provider.id}   
                      onClick={() => this.setProvider(vendor.id, provider.id)}
                    >
                      {provider.label}
                    </Radio>
                  ))}
                </FormGroup>
              </Panel.Body>
            </Panel>
          ))}
        </div>
      )
  }
}
  
export default PaymentMethods


// WEBPACK FOOTER //
// ./src/app/admin/components/PaymentMethods.jsx